/**
 * Layout Store Actions
 *
 * Contains all action implementations for the layout store.
 *
 * @module @store/layout/layoutActions
 */

import type { LayoutState, LayoutActions } from './layoutTypes';

/**
 * Creates the layout actions object.
 *
 * @param set - Zustand set function
 * @returns LayoutActions object
 */
export function createLayoutActions(
    set: (
        partial:
            | Partial<LayoutState>
            | ((state: LayoutState) => Partial<LayoutState>),
    ) => void,
): LayoutActions {
    return {
        /**
         * Toggles the navbar expansion state.
         */
        toggleNavbar: (): void => {
            set((s: LayoutState): Partial<LayoutState> => ({
                isNavbarExpanded: !s.isNavbarExpanded,
            }));
        },
    };
}
